export default {
  referer: state => state.referer,
  acted: state => state.acted,
  notice: state => state.notice,
  isLocked: state => state.isLocked,
  isLoading: state => state.loading
}
